import { Component, OnInit } from '@angular/core';
import { ToastService } from './toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit {
  eventEmitter: any; // actually of type EventEmitter
  alertClass = 'alert-primary';
  message = 'some message';
  toasts: any = [];
  constructor(private toastService: ToastService) { }

  ngOnInit() {
    this.eventEmitter = this.toastService.getEventEmitter();
    this.eventEmitter.subscribe(
      (result: any) => {
        this.toasts.push({ message: result.message, class: result.alertClass })
      });
  }

}
